import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  matchRoutes,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { clsx } from 'clsx';
import { TFunction } from 'i18next';

const initialPages = (t: TFunction) => [
  { name: t('orders.title'), slug: 'orders' },
  { name: t('orders.documents.title'), slug: 'documents' },
  { name: t('invoices.title'), slug: 'invoices' },
  // { name: t('orders.contracts.title'), slug: 'contracts' },
];

interface Props {
  showInvoicesTab: boolean;
}

const DahsboardInnerNavigation: React.FC<Props> = ({ showInvoicesTab }) => {
  const { t } = useTranslation();
  const [pages] = useState(() => {
    return showInvoicesTab
      ? initialPages(t)
      : initialPages(t).filter((page) => page.slug !== 'invoices');
  });
  const navigate = useNavigate();
  const location = useLocation();
  const { retailerId } = useParams();

  const handleNavigate = (slug: string) => {
    const url = `documents/${retailerId}/${slug}`;
    navigate(url);
  };

  const matchRoute = (slug: string) => {
    return matchRoutes([{ path: `documents/${slug}` }], location);
  };

  return (
    <div
      className="w-full bg-grey-100 font-li flex p-0-4 rounded-8-0 text-2-0 md:text-1-4 my-2-0"
      id="dashboardNavigation"
    >
      {pages.map((page) => (
        <div
          className={clsx(
            matchRoute(page.slug) &&
              'text-primary-black bg-primary-white rounded-8-0 shadow',
            'px-1-2 py-0-8 text-grey-700 mr-1-0 cursor-pointer transition-bg duration-200 ease-linear',
          )}
          key={page.slug}
          onClick={() => handleNavigate(page.slug)}
        >
          {page.name}
        </div>
      ))}
    </div>
  );
};

export default DahsboardInnerNavigation;
